// TODO: split is legacy, use table, for now still will be used in the bet history
export enum SixPlusPokerCardType {
    BOARD = 'board',
    PLAYER = 'player',
    DEALER = 'dealer',
    SPLIT = 'split',
}
